function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import __ from 'ramda/src/__';
import chain from 'ramda/src/chain';
import path from 'ramda/src/path';
import prop from 'ramda/src/prop';
import { stateGo } from 'redux-ui-router';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../../../reducers/selectors/customer.household.selectors';
import { retrieveOfferingRemovalContext } from '../../../../../reducers/actions/offering.disconnect.actions';
import { calculateChangeOfServiceQuote, submitChangeOfServiceOrderRemoval } from '../../../../../reducers/actions/offering.remove.actions';
import { retrieveWallet, selectPaymentMethod } from '../../../../../reducers/actions/customer.ewallet.actions';
import { retrieveSubscription, searchSubscriptions } from '../../../../../reducers/actions/customer.subscriptions.actions';
import LocaleKeys from '../../../../../locales/keys';
import { IsCalculatingQuoteSelector, IsRetrievingContextSelector, RemoveOfferItemsIdsSelector } from '../../../../../reducers/selectors/offering.disconnect.selectors';
import * as EWalletSelectors from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { BriefSubscriptionsSelector, CurrentSubscriptionSelector, IsFetchingDataSelector, UserCanIssueCreditToAlternatePaymentInstrument } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
import { IsSubmittingOrderSelector, QuoteOfferSelector, QuoteOfferRemainingAmountSelector } from '../../../../../reducers/selectors/offering.remove.selectors';
import { IsUnderContractForDisconnectOffers, OfferingsSelector, SelectedCustomerOfferingsCurrency } from '../../../../../reducers/selectors/disconnect.offers.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
import * as SubscriptionConstants from '../../../../shared/constants/subscriptions.constants';
import { DASHBOARD_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
import { setReloadSubscriberStateFlag } from '../../../../../reducers/actions/customer.actions';
var SUBSCRIPTIONS_SEARCH_CRITERIA = {
  IncludePaymentInstrumentInfo: true,
  IncludeRemoved: false,
  PageSize: 5,
  SortDirection: 2
};
var DisconnectOffersITVController = /*#__PURE__*/function () {
  function DisconnectOffersITVController($ngRedux, $state, $q, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, DisconnectOffersITVController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $q: $q,
      LocaleKeys: LocaleKeys,
      uiNotificationService: uiNotificationService,
      $timeout: $timeout,
      isDisconnecting: false
    });
    this.confirmationPopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        _this.confirmationPopupApi = event.api;
      }
    };
    this.removal = {
      changeImmediately: true,
      creditAmount: 0,
      creditAmountType: 'max',
      creditReason: null,
      customAmount: 0,
      sendNotification: true,
      terminationReason: null
    };
    this.metadataCodes = ['SubscriptionTerminationReason', 'CreditReasons', 'WaiveFeeReason'];
    this.onConfirmation = this.onConfirmation.bind(this);
  }
  return _createClass(DisconnectOffersITVController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canIssueCreditToAlternatePaymentMethod: UserCanIssueCreditToAlternatePaymentInstrument(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          isContractEndDate: IsUnderContractForDisconnectOffers(store),
          creditReasons: MetadataOptionsForCodeValuesSelector(CODES.CreditReasons, store),
          currency: SelectedCustomerOfferingsCurrency(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currentRemainingAmount: QuoteOfferRemainingAmountSelector(store),
          currentRemoval: QuoteOfferSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          eWalletError: EWalletSelectors.EwalletErrorSelector(store),
          isCalculatingQuote: IsCalculatingQuoteSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isFetchingEwalletData: EWalletSelectors.IsRetrievingEwalletDataSelector(store),
          isRetrievingContext: IsRetrievingContextSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          offerings: OfferingsSelector(store),
          paymentInstruments: EWalletSelectors.PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          removeOfferItemsIds: RemoveOfferItemsIdsSelector(store),
          selectedPaymentMethod: EWalletSelectors.SelectedPaymentMethodSelector(store),
          subscriptionTerminationReasons: MetadataOptionsForCodeValuesSelector(CODES.SubscriptionTerminationReason, store),
          subscriptions: BriefSubscriptionsSelector(store),
          userHasEWalletAdminAccess: EWalletSelectors.UserHasEWalletAdminAccess(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          waiveFeeReasons: MetadataOptionsForCodeValuesSelector(CODES.WaiveFeeReason, store)
        };
      };
      var controllerActions = {
        calculateChangeOfServiceQuote: calculateChangeOfServiceQuote,
        fetchCodeType: fetchCodeTypes,
        retrieveOfferingRemovalContext: retrieveOfferingRemovalContext,
        retrieveSubscription: retrieveSubscription,
        retrieveWallet: retrieveWallet,
        searchSubscriptions: searchSubscriptions,
        selectPaymentMethod: selectPaymentMethod,
        setReloadSubscriberStateFlag: setReloadSubscriberStateFlag,
        stateGo: stateGo,
        submitChangeOfServiceOrderRemoval: submitChangeOfServiceOrderRemoval
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        Object.assign(_this2, {
          state: state,
          actions: actions
        });
      });

      //Load all needed metadata codes
      this.metadataCodes.forEach(function (codeType) {
        if (!_this2.state.codeTypeLoaded(CODES[codeType])) {
          _this2.actions.fetchCodeType(CODES[codeType]);
        }
      });
      this.actions.searchSubscriptions(this.state.currentCustomerId, SUBSCRIPTIONS_SEARCH_CRITERIA).then(function () {
        return _this2.$q.all([_this2.actions.retrieveSubscription(_this2.state.currentCustomerId, {
          //for now just grabbing the first subscription might want to grab everything else
          Id: _this2.state.subscriptions[0].id
        }), _this2.actions.retrieveOfferingRemovalContext(_this2.state.removeOfferItemsIds, _this2.state.currentCustomerId), _this2.actions.retrieveWallet({
          customerId: _this2.state.currentCustomerId
        })]);
      }).then(function () {
        return _this2.actions.selectPaymentMethod(_this2.state.currentSubscription.PaymentInstrument);
      }).then(function () {
        return _this2.actions.calculateChangeOfServiceQuote(_this2.createRequest(), _this2.state.currentCustomerId);
      }).then(function () {
        _this2.removal.creditAmount = _this2.state.currentRemainingAmount;
      }).catch(function () {
        var message = path(['eWalletError', 'message'], _this2.state) || path(['subscriptionError', 'message'], _this2.state);
        if (message) {
          _this2.uiNotificationService.error(message, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
      });
    }
  }, {
    key: "createRequest",
    value: function createRequest() {
      var removeItemsArray = chain(prop('removeItems'), this.state.offerings);
      var removeOffersRequest = {
        ChangeImmediately: this.removal.changeImmediately,
        CreditAmount: this.removal.creditAmount,
        CreditPaymentInstrument: this.state.selectedPaymentMethod,
        CreditPaymentInstrumentId: this.state.selectedPaymentMethod.Id,
        CreditReason: this.removal.creditReason,
        RemoveItems: removeItemsArray,
        RemoveReasonCode: this.removal.terminationReason,
        SendNotification: this.removal.sendNotification
        //according to Muhamet we do not need OfferingId or SubscriptionId
      };
      return removeOffersRequest;
    }
  }, {
    key: "canCreatePaymentInstruments",
    get: function get() {
      return this.state.currentMemberCanCreatePaymentInstrument && this.state.userHasEWalletAdminAccess;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.state.isFetchingData || this.state.isFetchingEwalletData || this.state.isRetrievingContext || this.state.isCalculatingQuote || this.state.isSubmittingOrder;
    }
  }, {
    key: "headingText",
    value: function headingText() {
      return i18n.translate(this.state.removeOfferItemsIds ? this.LocaleKeys.DISCONNECT_OFFERS.REMOVE_OFFER : this.LocaleKeys.DISCONNECT_OFFERS.DISCONNECT_CUSTOMER);
    }
  }, {
    key: "isCurrentPaymentMethodRemoved",
    value: function isCurrentPaymentMethodRemoved() {
      return this.state.selectedPaymentMethod && this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.REMOVED;
    }
  }, {
    key: "confirmRemoval",
    value: function confirmRemoval() {
      if (this.disconnectOffersForm.$valid) {
        this.disconnectOffersForm.$setPristine();
        this.confirmationPopupApi.open();
      }
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(confirmed) {
      if (confirmed) {
        this.removeOffers();
      }
      this.confirmationPopupApi.close();
    }
  }, {
    key: "removeOffers",
    value: function removeOffers() {
      var _this3 = this;
      this.actions.submitChangeOfServiceOrderRemoval(this.createRequest(), this.state.currentCustomerId).then(function () {
        _this3.uiNotificationService.success(i18n.translate(_this3.LocaleKeys.DISCONNECT_OFFERS.REMOVE_SUCCESSFUL), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        /*
        * TODO:
        * PD-411357
        * Need to identify when the subscriber has no more offers left to trigger (Switches to disconnect state) below action
        */
        _this3.actions.setReloadSubscriberStateFlag(true);
        _this3.actions.stateGo(DASHBOARD_ROUTE, {
          'customerId': _this3.state.currentCustomerId
        });
      }).catch(function () {
        _this3.uiNotificationService.error(i18n.translate(_this3.LocaleKeys.DISCONNECT_OFFERS.REMOVE_UNSUCCESSFUL), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "handleSetEffectiveType",
    value: function handleSetEffectiveType() {
      this.calculateChangeOfService();
      this.removal.creditAmount = 0;
      this.removal.creditAmountType = 'max';
      this.removal.creditReason = null;
      this.removal.customAmount = 0;
    }
  }, {
    key: "calculateChangeOfService",
    value: function calculateChangeOfService() {
      var _this4 = this;
      this.actions.calculateChangeOfServiceQuote(this.createRequest(), this.state.currentCustomerId).then(function () {
        _this4.removal.creditAmount = _this4.state.currentRemainingAmount;
      });
    }
  }]);
}();
export default {
  template: require('./disconnect.offers.itv.html'),
  bindings: {},
  controller: DisconnectOffersITVController,
  controllerAs: 'DisconnectOffers'
};